import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export default class ThirdPartyKeys {

    /**
     * A list full of services, which are available to setup.
     */
    static available_services = [
        {
            text: "ipdata.co",
            value: "ipdata.co",
            description: "This service enables you to identify your users from their IP address, from where they are logging in.",
            website: "https://ipdata.co/",
            website_docs: "https://docs.ipdata.co/"
        }
    ];

    /**
     * Receives all the third party api keys from the project.
     * @param {Number} project_id The id of the project
     */
    static getAllKeys(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/project/thirdpartykeys.php",
                method: 'GET',
                params: {
                    _console_token: UserSession.token,
                    project: project_id
                }
            }).then(function (response) {
                resolve(response.data);
            });
        });
    }

    /**
     * Assigns an API key to a project.
     * @param {Number} project_id The id of the project
     * @param {String} service The service name
     * @param {String} api_key The api key, which should be defined for the service.
     */
    static assignKeyToProject(project_id, service, api_key) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/project/thirdpartykeys.php",
                method: 'POST',
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    service: service,
                    api_key: api_key
                }
            }).then(function (response) {
                resolve(response.data);
            });
        });
    }
}